if (!customElements.get('mobile-product-bar')) {
  customElements.define(
    'mobile-product-bar',
    class MobileProductBar extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.mainButton = this.productInfo?.querySelector(`#${this.dataset.mainButton}`);
        this.priceSource = this.productInfo?.querySelector(`#${this.dataset.priceSource}`);
        this.priceTarget = this.querySelector('[data-mobile-product-price]');
        this.submitButton = this.querySelector('[data-mobile-product-submit]');
        this.labelTarget = this.querySelector('[data-mobile-product-label]');
        this.titleElement = this.productInfo?.querySelector('.product__title');

        if (!this.mainButton || !this.submitButton) return;

        this.mainButtonVisible = false;
        this.productVisible = true;
        this.frameRequested = false;
        this.handleScroll = this.requestVisibilityUpdate.bind(this);
        this.handleSubmit = this.forwardSubmit.bind(this);

        this.submitButton.addEventListener('click', this.handleSubmit);
        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleScroll);

        this.mainButtonObserver = new IntersectionObserver(
          ([entry]) => {
            this.mainButtonVisible = entry.isIntersecting;
            this.requestVisibilityUpdate();
          },
          { threshold: 0.2 }
        );
        this.mainButtonObserver.observe(this.mainButton);

        this.productObserver = new IntersectionObserver(
          ([entry]) => {
            this.productVisible = entry.isIntersecting;
            this.requestVisibilityUpdate();
          },
          { threshold: 0 }
        );
        this.productObserver.observe(this.productInfo);

        this.contentObserver = new MutationObserver(() => this.syncContent());
        this.contentObserver.observe(this.mainButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
          childList: true,
          subtree: true,
        });
        if (this.priceSource) {
          this.contentObserver.observe(this.priceSource, { childList: true, subtree: true });
        }

        this.syncContent();
        this.requestVisibilityUpdate();
      }

      disconnectedCallback() {
        this.submitButton?.removeEventListener('click', this.handleSubmit);
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleScroll);
        this.mainButtonObserver?.disconnect();
        this.productObserver?.disconnect();
        this.contentObserver?.disconnect();
      }

      syncContent() {
        const disabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
        const mainLabel = this.mainButton.querySelector('span')?.textContent?.trim();

        this.submitButton.disabled = disabled;
        if (mainLabel) this.labelTarget.textContent = mainLabel;
        if (this.priceSource && this.priceTarget) this.priceTarget.innerHTML = this.priceSource.innerHTML;
      }

      forwardSubmit() {
        if (!this.submitButton.disabled) this.mainButton.click();
      }

      requestVisibilityUpdate() {
        if (this.frameRequested) return;
        this.frameRequested = true;
        requestAnimationFrame(() => {
          this.frameRequested = false;
          this.updateVisibility();
        });
      }

      updateVisibility() {
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const titleReached =
          !this.titleElement || this.titleElement.getBoundingClientRect().top < window.innerHeight * 0.78;
        const visible = isMobile && this.productVisible && titleReached && !this.mainButtonVisible;

        this.dataset.visible = visible.toString();
        this.setAttribute('aria-hidden', (!visible).toString());
      }
    }
  );
}
